import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbFleetConfigConstParam extends IAloDbBaseConstParam {
    FLC_ID:number|null  
    FLE_ID :number|null
    FLC_IS_CURRENT :boolean 
    FLC_DATADD :string|null
    FLC_RAW:string|null
  }

export class AloDbFleetConfig extends AloDbBase {
        
    public FLC_ID:number|null    
    public FLE_ID :number|null
    public FLC_IS_CURRENT :boolean 
    public FLC_DATADD:Date|null
    public FLC_RAW:string|null
    
    
    constructor({FLC_ID = null,FLE_ID = null,FLC_IS_CURRENT=false,FLC_DATADD = null,FLC_RAW = null,...args }:IAloDbFleetConfigConstParam = {} as IAloDbFleetConfigConstParam) {
        super(args)
        this.FLC_ID = FLC_ID
        this.FLE_ID = FLE_ID
        this.FLC_IS_CURRENT = FLC_IS_CURRENT       
        this.FLC_DATADD = FLC_DATADD?new Date(FLC_DATADD):null 
        this.FLC_RAW = FLC_RAW
    }

    static createAloDbFleetConfigArray(datas:any) {
        return new AloBaseArray(AloDbFleetConfig,datas)
    }

    static createAloDbFleetConfigWithDetail(data:any) {
        return new AloDbFleetConfig({...data,detailLoaded:true})
    }
}
